// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: xeCXagYw-zAc

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import { TabsContainer } from "@plasmicpkgs/plasmic-tabs";
import { TabButton } from "@plasmicpkgs/plasmic-tabs";
import Button from "../../Button"; // plasmic-import: lBHNzts6tFyj/component
import { TabUnderline } from "@plasmicpkgs/plasmic-tabs";
import { TabContent } from "@plasmicpkgs/plasmic-tabs";

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicVoiceOptions.module.css"; // plasmic-import: xeCXagYw-zAc/css

import ChecksvgIcon from "../plasmic_tabs/icons/PlasmicIcon__Checksvg"; // plasmic-import: zq2s7N0xWucT/icon
import IconIcon from "../plasmic_tabs/icons/PlasmicIcon__Icon"; // plasmic-import: 8K40faRNhuCj/icon

createPlasmicElementProxy;

export type PlasmicVoiceOptions__VariantMembers = {};
export type PlasmicVoiceOptions__VariantsArgs = {};
type VariantPropType = keyof PlasmicVoiceOptions__VariantsArgs;
export const PlasmicVoiceOptions__VariantProps = new Array<VariantPropType>();

export type PlasmicVoiceOptions__ArgsType = {
  recommendedVoices?: React.ReactNode;
  allVoices?: React.ReactNode;
};
type ArgPropType = keyof PlasmicVoiceOptions__ArgsType;
export const PlasmicVoiceOptions__ArgProps = new Array<ArgPropType>(
  "recommendedVoices",
  "allVoices"
);

export type PlasmicVoiceOptions__OverridesType = {
  root?: p.Flex<"div">;
  tabsContainer?: p.Flex<typeof TabsContainer>;
  recommendedVoices?: p.Flex<"div">;
  allVoices?: p.Flex<"div">;
  tabUnderline?: p.Flex<typeof TabUnderline>;
};

export interface DefaultVoiceOptionsProps {
  recommendedVoices?: React.ReactNode;
  allVoices?: React.ReactNode;
  className?: string;
}

const $$ = {};

function PlasmicVoiceOptions__RenderFunc(props: {
  variants: PlasmicVoiceOptions__VariantsArgs;
  args: PlasmicVoiceOptions__ArgsType;
  overrides: PlasmicVoiceOptions__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.root
      )}
    >
      <TabsContainer
        data-plasmic-name={"tabsContainer"}
        data-plasmic-override={overrides.tabsContainer}
        className={classNames("__wab_instance", sty.tabsContainer)}
        initialKey={"tab1"}
        mountMode={"mountLazily"}
        previewAll={false}
        previewKey={``}
      >
        <ph.DataCtxReader>
          {$ctx => (
            <div className={classNames(projectcss.all, sty.freeBox__hq5Qe)}>
              <div className={classNames(projectcss.all, sty.freeBox__rfYU)}>
                <TabButton
                  className={classNames("__wab_instance", sty.tabButton__jCKh)}
                  tabKey={"tab1"}
                >
                  <Button
                    className={classNames("__wab_instance", sty.button__dSg5E)}
                  >
                    <div
                      data-plasmic-name={"recommendedVoices"}
                      data-plasmic-override={overrides.recommendedVoices}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.recommendedVoices
                      )}
                    >
                      {"Recommended Voices"}
                    </div>
                  </Button>
                </TabButton>
                <TabButton
                  className={classNames("__wab_instance", sty.tabButton__ipSqo)}
                  tabKey={"tab2"}
                >
                  <Button>
                    <div
                      data-plasmic-name={"allVoices"}
                      data-plasmic-override={overrides.allVoices}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.allVoices
                      )}
                    >
                      {"All Voices"}
                    </div>
                  </Button>
                </TabButton>
                <TabUnderline
                  data-plasmic-name={"tabUnderline"}
                  data-plasmic-override={overrides.tabUnderline}
                  className={classNames("__wab_instance", sty.tabUnderline)}
                />
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__bIx5F)}>
                <TabContent
                  className={classNames(
                    "__wab_instance",
                    sty.tabContent__udp9D
                  )}
                  tabKey={"tab1"}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox__hUZuJ)}
                  >
                    <div
                      className={classNames(projectcss.all, sty.freeBox__zDyDg)}
                    >
                      {p.renderPlasmicSlot({
                        defaultContents: "This is some tab content",
                        value: args.recommendedVoices
                      })}
                    </div>
                  </div>
                </TabContent>
                <TabContent
                  className={classNames(
                    "__wab_instance",
                    sty.tabContent__xMyeD
                  )}
                  tabKey={"tab2"}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox__plSl3)}
                  >
                    {p.renderPlasmicSlot({
                      defaultContents: "Some content for tab 2",
                      value: args.allVoices
                    })}
                  </div>
                </TabContent>
              </div>
            </div>
          )}
        </ph.DataCtxReader>
      </TabsContainer>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "tabsContainer",
    "recommendedVoices",
    "allVoices",
    "tabUnderline"
  ],
  tabsContainer: [
    "tabsContainer",
    "recommendedVoices",
    "allVoices",
    "tabUnderline"
  ],
  recommendedVoices: ["recommendedVoices"],
  allVoices: ["allVoices"],
  tabUnderline: ["tabUnderline"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  tabsContainer: typeof TabsContainer;
  recommendedVoices: "div";
  allVoices: "div";
  tabUnderline: typeof TabUnderline;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicVoiceOptions__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicVoiceOptions__VariantsArgs;
    args?: PlasmicVoiceOptions__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicVoiceOptions__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicVoiceOptions__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicVoiceOptions__ArgProps,
          internalVariantPropNames: PlasmicVoiceOptions__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicVoiceOptions__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicVoiceOptions";
  } else {
    func.displayName = `PlasmicVoiceOptions.${nodeName}`;
  }
  return func;
}

export const PlasmicVoiceOptions = Object.assign(
  // Top-level PlasmicVoiceOptions renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    tabsContainer: makeNodeComponent("tabsContainer"),
    recommendedVoices: makeNodeComponent("recommendedVoices"),
    allVoices: makeNodeComponent("allVoices"),
    tabUnderline: makeNodeComponent("tabUnderline"),

    // Metadata about props expected for PlasmicVoiceOptions
    internalVariantProps: PlasmicVoiceOptions__VariantProps,
    internalArgProps: PlasmicVoiceOptions__ArgProps
  }
);

export default PlasmicVoiceOptions;
/* prettier-ignore-end */
